import { useState } from 'react';
import { FONT_SCALES, useFontSize } from '../../context/FontSizeContext';
import { ChevronLeft, ChevronRight, Type } from 'lucide-react';

const FontSizeControls = () => {
  const { fontScale, increaseFontSize, decreaseFontSize, resetFontSize } = useFontSize();
  const [isExpanded, setIsExpanded] = useState(false);
  
  const displayScale = () => {
    const scaleValue = FONT_SCALES[fontScale];
    return fontScale === 'base' ? '100%' : `${Math.round(scaleValue * 100)}%`;
  };
  
  return (
    <div className="hidden sm:fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-white rounded-lg shadow-lg overflow-hidden">
      {isExpanded ? (
        <div className="flex items-center p-2">
          <button 
            onClick={decreaseFontSize}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
            aria-label="Decrease font size"
          >
            A-
          </button>
          <span className="min-w-[3ch] text-center mx-2">
            {displayScale()}
          </span>
          <button 
            onClick={increaseFontSize}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
            aria-label="Increase font size"
          >
            A+
          </button>
          <button 
            onClick={resetFontSize}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 transition-colors ml-2"
            aria-label="Reset font size"
          >
            Reset
          </button>
          <button
            onClick={() => setIsExpanded(false)}
            className="p-2 ml-2 text-gray-600 hover:text-gray-800 transition-colors"
            aria-label="Collapse font size controls"
          >
            <ChevronLeft size={20} />
          </button>
        </div>
      ) : (
        <button
          onClick={() => setIsExpanded(true)}
          className="p-2 flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
          aria-label="Expand font size controls"
        >
          <Type size={20} />
          <ChevronRight size={20} />
        </button>
      )}
    </div>
  );
};

export default FontSizeControls;